import {initInScope, onFind} from "@elements/init-modules-in-scope";
import {on, hasClass, addClass, removeClass, closest, findAllIn, findIn, removeAttribute, setAttribute, find} from "@elements/dom-utils";
import axios from "axios";
import {showNotification, clearAll} from '@elements/alert-notification';

export function init() {
    let pendingRequest;

    onFind('.js-project-wishlist__list', function (listContainer) {
        let container = closest('.js-project-wishlist', listContainer),
            config = JSON.parse(listContainer.getAttribute('data-wishlist-config')),
            productId = listContainer.getAttribute('data-product-id');


        getWishlistState(productId, config.info, listContainer);

        let createForm = findIn('.js-project-wishlist__form', container);
        if (createForm) {
            let result = findIn('.js-project-wishlist__result', container),
                loading = findIn('.js-project-wishlist__loading', container);

            on('submit', (evt) => {
                evt.preventDefault();
                removeAttribute('hidden', loading);

                pendingRequest = axios({
                    method: 'POST',
                    url: createForm.getAttribute('data-action'),
                    headers: {
                        'pragma': 'no-cache',
                        'cache-control': 'no-cache'
                    },
                    data: new FormData(createForm)
                }).then(({data}) => {
                    if (data.success) {
                        result.innerHTML = data.html;
                    }
                    initInScope(result);
                    setAttribute('hidden', true, loading);

                    clearAll();
                    showNotification(data.__alertNotification[0])
                });

            }, createForm);
        }
    });

    onFind('.js-project-wishlist__btn', function (toggleButton) {
        let listContainer = closest('.js-project-wishlist__list', toggleButton),
            config = JSON.parse(listContainer.getAttribute('data-wishlist-config')),
            productId = listContainer.getAttribute('data-product-id'),
            itemName = listContainer.getAttribute('data-event-tracking-item-name'),
            itemId = listContainer.getAttribute('data-event-tracking-item-id');

        on('click', () => {
            let projectId = closest('.js-project-wishlist__item--project', toggleButton).getAttribute('data-project-id'),
                roomId = closest('.js-project-wishlist__item[data-room-id]', toggleButton) ? closest('.js-project-wishlist__item[data-room-id]', toggleButton).getAttribute('data-room-id') : null;

            let countContainer = null;
            if (findIn('.js-project-wishlist__item-count', closest('.js-project-wishlist__item', toggleButton))) {
                countContainer = findIn('.js-project-wishlist__item-count', closest('.js-project-wishlist__item', toggleButton));
            }

            if (hasClass('is-active', toggleButton)) {
                removeClass('is-active', toggleButton);
                updateWishlsit(config.remove, projectId, roomId, productId, true).then((res) => {
                    if (res.data.success && countContainer) {
                        countContainer.innerHTML = res.data.count;
                    }

                    getWishlistOverviewState(productId, find('.js-project-wishlist-info[data-product-id="'+ productId +'"]').getAttribute('data-wishlist-state'), find('.js-project-wishlist-info[data-product-id="'+ productId +'"]'));
                });

                window.dataLayer.push({
                    "event": "myXAL_remove_from_wishlist",
                    "project_id": projectId,
                    "room_id": roomId,
                    "item_id": itemId,
                    "item_name": itemName
                });
            } else {
                addClass('is-active', toggleButton);
                updateWishlsit(config.add, projectId, roomId, productId).then((res) => {
                    if (res.data.success && countContainer) {
                        countContainer.innerHTML = res.data.count;
                    }
                    getWishlistOverviewState(productId, find('.js-project-wishlist-info[data-product-id="'+ productId +'"]').getAttribute('data-wishlist-state'), find('.js-project-wishlist-info[data-product-id="'+ productId +'"]'));
                });

                window.dataLayer.push({
                    "event": "myXAL_add_to_wishlist",
                    "project_id": projectId,
                    "room_id": roomId,
                    "item_id": itemId,
                    "item_name": itemName
                });
            }
        }, toggleButton);
    });

    onFind('.js-project-wishlist__item-form', function (addForm) {
        let projectGroup = closest('.js-project-wishlist__item--project', addForm),
            loading = findIn('.js-project-wishlist__item-loading', projectGroup),
            result = findIn('.js-project-wishlist__item-result', projectGroup),
            listContainer = closest('.js-project-wishlist__list', addForm);

        on('submit', (evt) => {
            evt.preventDefault();

            removeAttribute('hidden', loading);

            pendingRequest = axios({
                method: 'POST',
                url: addForm.getAttribute('data-action'),
                headers: {
                    'pragma': 'no-cache',
                    'cache-control': 'no-cache'
                },
                data: new FormData(addForm)
            }).then(({data}) => {
                if (data.success) {
                    result.innerHTML = data.html;
                }
                console.log('init in scope', result)
                initInScope(result);
                getWishlistState(listContainer.getAttribute('data-product-id'), listContainer);

                setAttribute('hidden', true, loading);

                clearAll();
                showNotification(data.__alertNotification[0])
            });

        }, addForm);
    });

    onFind('.js-project-wishlist-info', function (infoItem) {
        getWishlistOverviewState(infoItem.getAttribute('data-product-id'), infoItem.getAttribute('data-wishlist-state'), infoItem);
    });
}

export function updateWishlsit(url, projectId, roomId, productId) {
    let data = {
        projectId, roomId, productId
    }

    return axios({
        method: 'POST',
        url: url,
        headers: {
            'pragma': 'no-cache',
            'cache-control': 'no-cache'
        },
        data: data
    });
}


export function getWishlistState(productId, url, listContainer) {
    axios({
        method: 'POST',
        url: url,
        headers: {
            'pragma': 'no-cache',
            'cache-control': 'no-cache'
        },
        data: {
            productId: productId
        }
    }).then(({data}) => {
        if (data.success) {
            data.projects.map((projectObject) => {
                let key = projectObject.id;
                let project = findIn('.js-project-wishlist__item[data-project-id="'+ key +'"]', listContainer);

                if (projectObject.notAssigned) {
                    addClass('is-active', findIn('.js-project-wishlist__btn', project));
                }

                if (projectObject.rooms.length > 0 && project) {
                    projectObject.rooms.map((roomId) => {
                        let room = findIn('.js-project-wishlist__item[data-room-id="'+ roomId +'"]', project);
                        if (room) {
                            addClass('is-active', findIn('.js-project-wishlist__btn', room));
                        }
                    });
                }
            });
        }
    });
}

export function getWishlistOverviewState(productId, url, infoItem) {
    axios({
        method: 'POST',
        url: url,
        headers: {
            'pragma': 'no-cache',
            'cache-control': 'no-cache'
        },
        data: {
            productId: productId
        }
    }).then(({data}) => {
        if (data.success) {
            removeClass('is-active', infoItem);

            data.projects.map((projectObject) => {
                if (projectObject.rooms.length > 0 || projectObject.notAssigned === true) {
                    addClass('is-active', infoItem);
                }
            });
        }
    });
}